import ClubApplicationSetting from '../dto/ClubApplicationSetting';
import Error from '../model/Error';
import axios from 'axios';

export default class ClubApplicationSettingRepository {
    static find(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/options/member-application`)
                .then(response => resolve(ClubApplicationSetting.fromData(response.data.data)))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static update(clubId, clubApplicationSetting) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/options/member-application`,
                    clubApplicationSetting.serialize()
                )
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
